import { SxProps, Theme } from '@mui/material';

export const imageDpBestOfferSX: SxProps<Theme> = {
	objectFit: 'cover',
	width: 'auto',
	height: 'auto',
};
